import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';

interface Props {
  open: boolean;
  title: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  onClose: () => void;
  footer?: ReactNode;
  children: ReactNode;
}

const SIZE: Record<NonNullable<Props['size']>, string> = {
  sm: '400px',
  md: '600px',
  lg: '900px',
  xl: '1280px',
};

export function Modal({ open, title, size = 'md', onClose, footer, children }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return createPortal(
    <div
      className="ts-drawer-overlay open"
      // POS layer (.pos-wrap z-index:500) дээр Modal заавал гарах ёстой —
      // эс тэгвэл backdrop pointer-event-уудыг блоклох ба товчнууд click-д хариулахгүй.
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 700 }}
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        className="ts-card ts-modal"
        style={{
          width: SIZE[size],
          maxWidth: '95vw',
          maxHeight: '90vh',
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ts-drawer-header">
          <h3 className="ts-drawer-title">{title}</h3>
          <button
            type="button"
            className="ts-drawer-close"
            onClick={onClose}
            aria-label="Хаах"
          >
            <i className="bi bi-x-lg" />
          </button>
        </div>
        <div className="ts-drawer-body" style={{ flex: 1 }}>
          {children}
        </div>
        {footer ? <div className="ts-drawer-footer">{footer}</div> : null}
      </div>
    </div>,
    document.body,
  );
}
